import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as o, openBlock as d, normalizeClass as n, createElementVNode as i } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconZoomIn",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ i("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 5.5a4.5 4.5 0 1 1 8.016 2.81l1.838 1.838a.5.5 0 1 1-.707.707L8.309 9.016A4.5 4.5 0 0 1 1 5.5Zm1 0a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0Z",
  fill: "currentColor"
}, null, -1), m = /* @__PURE__ */ i("path", {
  d: "M5.5 3.5A.5.5 0 0 1 6 4v1h1a.5.5 0 1 1 0 1H6v1a.5.5 0 1 1-1 0V6H4a.5.5 0 0 1 0-1h1V4a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), u = [
  _,
  m
];
function h(e, f, r, p, v, a) {
  return d(), o("svg", {
    "aria-label": r.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--zoom-in"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Zoom In",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, u, 10, c);
}
const z = /* @__PURE__ */ l(s, [["render", h]]);
export {
  z as default
};
//# sourceMappingURL=zoom-in.js.map
